var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    _vm._b({ staticClass: "c-list-component" }, "table", _vm.$attrs, false),
    [
      _vm._l(_vm.rows, function(row) {
        return [
          _c("list-row", {
            ref: "listRow",
            refInFor: true,
            attrs: { row: row }
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }